import { recurringCostMatchingAPI } from '../../lib/api';
import { MatchRepairPanel } from './MatchRepairPanel';

// Repairs recurring_cost_matches confirmed at the match-doc level whose
// transaction was never stamped reconciled/categorized (repairable), and
// surfaces matches whose transaction_id no longer resolves at all
// (orphaned -- e.g. hard-deleted by a mock-data/bank-account purge).
// Neither bucket self-heals: once a match reaches status="confirmed" its
// instance is excluded from every future matching run (see
// services/recurring_cost_matcher.py::classify_confirmed_matches).
// Thin config wrapper over the shared MatchRepairPanel (see that file for
// the card/preview/apply/release behavior) -- kept as explicit local
// functions (not a bare object reference) so the API calls stay visible by
// name here, same contract recurringCostMatchRepairPanel.test.js's
// live-wiring check reads off this file's own source.
const repairPreview = () => recurringCostMatchingAPI.repairPreview();
const repairApply = () => recurringCostMatchingAPI.repairApply();
const repairRelease = (matchId) => recurringCostMatchingAPI.repairRelease(matchId);

const REPAIRABLE_COLUMNS = [
  { key: 'id', label: 'Match ID' },
  { key: 'transaction_id', label: 'Transaction ID' },
  { key: 'confirm_step', label: 'Confirm step', className: 'px-3 py-2 tabular-nums text-xs' },
];

const ORPHANED_COLUMNS = [
  { key: 'id', label: 'Match ID' },
  { key: 'transaction_id', label: 'Dead transaction ID' },
];

const RELEASE_BUCKETS = [
  {
    key: 'orphaned',
    summaryLabel: 'orphaned',
    caption: 'Orphaned (transaction no longer exists -- release to reopen the instance)',
    columns: ORPHANED_COLUMNS,
  },
];

export function RecurringCostMatchRepairPanel() {
  return (
    <MatchRepairPanel
      title="Recurring Cost Match Repair"
      description="Finds recurring_cost_matches confirmed at the match-doc level whose
          transaction was never stamped reconciled/categorized (repairable),
          or whose transaction no longer exists at all (orphaned), and
          completes/releases them via the same idempotent helpers every
          other confirm path uses."
      repairPreview={repairPreview}
      repairApply={repairApply}
      repairRelease={repairRelease}
      repairableColumns={REPAIRABLE_COLUMNS}
      releaseBuckets={RELEASE_BUCKETS}
    />
  );
}
